import { render, staticRenderFns } from "./PlatformFilters.vue?vue&type=template&id=7f02501e"
import script from "./PlatformFilters.vue?vue&type=script&lang=js"
export * from "./PlatformFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports